import { useState } from 'react';

interface WorkPaper {
  id: number;
  title: string;
  presenter: string;
  alternative: string;
}

const workPapers: WorkPaper[] = [
  { 
    id: 1, 
    title: 'خريطة احتياجات الشباب في المملكة: قراءة تحليلية', 
    presenter: 'د. فهد العرابي الحارثي – خبير استراتيجي وباحث في قضايا الشباب والتنمية',
    alternative: 'د. عبد العزيز القحطاني – أستاذ سياسات عامة\nد. عبد الله الفوزان – خبير تنمية اجتماعية'
  },
  { 
    id: 2, 
    title: 'تمكين الشباب بين السياسات والواقع', 
    presenter: 'معالي الأستاذ أحمد الراجحي – وزير الموارد البشرية والتنمية الاجتماعية',
    alternative: 'د. أحمد العيسى – وزير التعليم السابق\nد. ماجد القصبي – وزير التجارة السابق'
  },
  { 
    id: 3, 
    title: 'دور الجمعيات الشبابية في سد فجوات الاحتياج', 
    presenter: 'أ. عبد الله آل طاوي – رئيس مجلس إدارة جمعية شبابية رائدة / خبير قطاع غير ربحي',
    alternative: 'أ. خالد اليوسف – مدير مؤسسة غير ربحية\nأ. محمد الغامدي – مستشار قطاع ثالث'
  },
  { 
    id: 4, 
    title: 'الشباب وسوق العمل المستقبلي', 
    presenter: 'د. بدر الدليم – خبير موارد بشرية واستشراف المستقبل الوظيفي',
    alternative: 'د. فهد العثمان\nأ. تركي الجعويني'
  },
  { 
    id: 5, 
    title: 'القيم والهوية الوطنية لدى الشباب', 
    presenter: 'د. عبدالعزيز الخضيري – أكاديمي وباحث في القيم والهوية الوطنية',
    alternative: 'د. عبدالله الفوزان\nد. محمد العبدالكريم'
  },
  { 
    id: 6, 
    title: 'التحول الرقمي وأثره على تطلعات الشباب', 
    presenter: 'م. عبد الله السواحة – وزير الاتصالات وتقنية المعلومات',
    alternative: 'أ. أسامة الزامل\nم. فيصل السيف'
  },
  { 
    id: 7, 
    title: 'الصحة النفسية للشباب: من التشخيص إلى السياسات الوقائية', 
    presenter: 'د. خالد النمر – استشاري وباحث في الصحة النفسية والسلوكية',
    alternative: 'د. سامي الحمود\nد. مها التميمي'
  },
  { 
    id: 8, 
    title: 'الشباب والاقتصاد الاجتماعي: فرص العمل غير التقليدية', 
    presenter: 'د. عبد الله الدبيخي – خبير اقتصاد اجتماعي وريادة أعمال',
    alternative: '-'
  },
  { 
    id: 9, 
    title: 'الفجوة بين التعليم وسوق العمل: مسؤولية من؟', 
    presenter: 'د. ماجد القصبي – وزير التجارة (سابقاً) وخبير سياسات تعليمية وتنموية',
    alternative: '-'
  },
  { 
    id: 10, 
    title: 'مشاركة الشباب في المجالس واللجان المحلية: التحديات والفرص', 
    presenter: 'د. سامي فقيه – خبير حوكمة ومشاركة مجتمعية',
    alternative: '-'
  },
  { 
    id: 11, 
    title: 'احتياجات الشباب في المناطق الطرفية والقرى', 
    presenter: 'د. فهد بن جمعة – خبير تنمية مجتمعات محلية',
    alternative: '-'
  },
  { 
    id: 12, 
    title: 'الإعلام الجديد وتشكيل وعي الشباب', 
    presenter: 'أ. أحمد الغامدي – إعلامي وخبير منصات رقمية',
    alternative: '-'
  },
  { 
    id: 13, 
    title: 'القيادة القيمية للشباب في عصر التحولات المتسارعة', 
    presenter: 'د. عبدالكريم بكار – مفكر وباحث في القيادة والقيم',
    alternative: '-'
  },
  { 
    id: 14, 
    title: 'قياس الأثر في المبادرات الشبابية: من النشاط إلى التغيير', 
    presenter: 'د. خالد الشامي – خبير قياس أثر وتنمية اجتماعية',
    alternative: '-'
  },
  { 
    id: 15, 
    title: 'الإستراتيجية الشبابية (من الوزارة)', 
    presenter: 'متخصص',
    alternative: '-'
  },
];

interface AccordionItem {
  id: number;
  title: string;
}

const workshops: AccordionItem[] = [
  { id: 1, title: 'تصميم المبادرات الشبابية المبنية على الاحتياج (90 دقيقة)' },
  { id: 2, title: 'أدوات قياس الأثر في البرامج الشبابية (90 دقيقة)' },
  { id: 3, title: 'إشراك الشباب في صناعة القرار المحلي (90 دقيقة)' },
  { id: 4, title: 'الشراكات الفاعلة بين الجمعيات والقطاع الخاص (90 دقيقة)' },
];

export default function WorkContent() {
  const [openSection, setOpenSection] = useState<'papers' | 'workshops' | null>(null);

  const toggleSection = (section: 'papers' | 'workshops') => {
    setOpenSection(prev => prev === section ? null : section);
  };

  return (
    <section id="work-content" className="py-10 md:py-20 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 rounded-full text-sm font-medium mb-4">
            المحتوى العلمي
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            أوراق العمل وورش العمل
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            محتوى علمي متميز يقدمه نخبة من الخبراء والمتخصصين في قضايا الشباب
          </p>
        </div>

        {/* Accordion Container */}
        <div className="space-y-4">
          {/* Work Papers Accordion */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <button
              onClick={() => toggleSection('papers')}
              className="w-full flex items-center justify-between p-6 text-right hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl text-white">
                  <i className="ri-file-paper-2-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">عناوين أوراق العمل المقترحة</h3>
                  <p className="text-gray-500 text-sm mt-1">{workPapers.length} أوراق عمل علمية</p>
                </div>
              </div>
              <div className={`w-10 h-10 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600 transition-transform duration-300 ${openSection === 'papers' ? 'rotate-180' : ''}`}>
                <i className="ri-arrow-down-s-line text-xl"></i>
              </div>
            </button>
            
            <div className={`grid transition-all duration-300 ease-in-out ${openSection === 'papers' ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
              <div className="overflow-hidden">
                <div className="px-6 pb-6">
                {/* عرض بطاقات في الجوال */}
                <div className="md:hidden space-y-3">
                  {workPapers.map((paper, index) => (
                    <div
                      key={paper.id}
                      className={`rounded-xl p-4 border border-emerald-100 ${index % 2 === 0 ? 'bg-white' : 'bg-emerald-50/50'}`}
                    >
                      <div className="flex items-start gap-3 mb-3">
                        <div className="w-8 h-8 shrink-0 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg text-white font-bold text-xs">
                          {paper.id}
                        </div>
                        <h4 className="text-sm font-bold text-gray-800 leading-snug">{paper.title}</h4>
                      </div>
                      <div className="flex items-start gap-2 mb-2">
                        <i className="ri-user-line text-emerald-500 text-sm mt-0.5 shrink-0"></i>
                        <p className="text-xs text-gray-700 leading-relaxed">{paper.presenter}</p>
                      </div>
                      {paper.alternative !== '-' && (
                        <div className="flex items-start gap-2 mt-2 pt-2 border-t border-emerald-100">
                          <i className="ri-swap-line text-amber-500 text-sm mt-0.5 shrink-0"></i>
                          <p className="text-xs text-gray-500 leading-relaxed whitespace-pre-line">{paper.alternative}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {/* عرض جدول في الديسكتوب */}
                <div className="hidden md:block bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl p-6 overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b-2 border-emerald-200">
                        <th className="text-right py-3 px-4 font-bold text-gray-800 bg-emerald-100 rounded-tr-lg">م</th>
                        <th className="text-right py-3 px-4 font-bold text-gray-800 bg-emerald-100">أوراق العمل</th>
                        <th className="text-right py-3 px-4 font-bold text-gray-800 bg-emerald-100">المقدم</th>
                        <th className="text-right py-3 px-4 font-bold text-gray-800 bg-emerald-100 rounded-tl-lg">البديل</th>
                      </tr>
                    </thead>
                    <tbody>
                      {workPapers.map((paper, index) => (
                        <tr
                          key={paper.id}
                          className={`border-b border-emerald-100 hover:bg-white transition-colors ${index % 2 === 0 ? 'bg-white/50' : 'bg-white/30'}`}
                        >
                          <td className="py-4 px-4 align-top">
                            <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg text-white font-bold text-xs">
                              {paper.id}
                            </div>
                          </td>
                          <td className="py-4 px-4 font-medium text-gray-800 align-top">{paper.title}</td>
                          <td className="py-4 px-4 text-gray-700 align-top text-sm leading-relaxed">{paper.presenter}</td>
                          <td className="py-4 px-4 text-gray-600 align-top text-sm leading-relaxed whitespace-pre-line">{paper.alternative}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                </div>
              </div>
            </div>
          </div>

          {/* Workshops Accordion */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <button
              onClick={() => toggleSection('workshops')}
              className="w-full flex items-center justify-between p-6 text-right hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl text-white">
                  <i className="ri-presentation-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">عناوين ورش العمل المقترحة</h3>
                  <p className="text-gray-500 text-sm mt-1">{workshops.length} ورش عمل تطبيقية</p>
                </div>
              </div>
              <div className={`w-10 h-10 flex items-center justify-center rounded-full bg-amber-100 text-amber-600 transition-transform duration-300 ${openSection === 'workshops' ? 'rotate-180' : ''}`}>
                <i className="ri-arrow-down-s-line text-xl"></i>
              </div>
            </button>
            
            <div className={`grid transition-all duration-300 ease-in-out ${openSection === 'workshops' ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
              <div className="overflow-hidden">
                <div className="px-6 pb-6">
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-4">
                  <div className="space-y-3">
                    {workshops.map((workshop) => (
                      <div
                        key={workshop.id}
                        className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-0.5"
                      >
                        <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-amber-500 to-orange-600 rounded-lg text-white font-bold text-sm shrink-0">
                          {workshop.id}
                        </div>
                        <div className="flex-1">
                          <h4 className="text-gray-800 font-medium">{workshop.title}</h4>
                        </div>
                        <div className="flex items-center gap-2 text-amber-600 bg-amber-50 px-3 py-1 rounded-full text-sm">
                          <i className="ri-time-line"></i>
                          <span>90 دقيقة</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Info Cards */}
        <div className="grid md:grid-cols-2 gap-6 mt-12">
          <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl p-6 text-white">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                <i className="ri-lightbulb-line text-2xl"></i>
              </div>
              <h4 className="text-lg font-bold">أوراق العمل</h4>
            </div>
            <p className="text-white/90 text-sm leading-relaxed">
              أوراق علمية محكّمة تقدم رؤى تحليلية معمقة حول احتياجات الشباب وتحدياتهم في مختلف المجالات
            </p>
          </div>
          <div className="bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl p-6 text-white">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
                <i className="ri-tools-line text-2xl"></i>
              </div>
              <h4 className="text-lg font-bold">ورش العمل</h4>
            </div>
            <p className="text-white/90 text-sm leading-relaxed">
              ورش تطبيقية تفاعلية تهدف لإكساب المشاركين مهارات عملية وأدوات قابلة للتطبيق في مجال العمل الشبابي
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
